module.exports = __webpack_public_path__ + "img/modif_date.426097c1.png";